import uuid from 'uuid/v4';
import Platform from 'platform';
import * as firebase from 'firebase/app';
import { CAROUSEL_ITEM_THUMBNAIL } from './config/Thumbnail';
import { phoneCodes } from './config/phoneCodes';

const PLATFORM = ['chrome', 'firefox', 'safari', 'android', 'ios'];

export const parseQuery = (queryString) => {
  return queryString
    .slice(1)
    .split('&')
    .map((q) => q.split('='))
    .reduce((acc, cur) => {
      acc[cur[0]] = cur[1];
      return acc;
    }, {});
};

export const getDeviceId = () => {
  let deviceId = localStorage.getItem('device_uuid');

  if (deviceId) {
    return deviceId;
  }

  const uid = uuid();

  localStorage.setItem('device_uuid', uid);
  return uid;
};

export const generateDeviceInfo = () => {
  let platform = Platform.name.toLowerCase().split(' ')[0];

  if (PLATFORM.indexOf(platform) === -1) {
    const alternativePlatform = Platform.os.family.toLowerCase();

    if (PLATFORM.indexOf(alternativePlatform) !== -1) {
      platform = alternativePlatform;
    } else {
      platform = 'chrome';
    }
  }

  const deviceInfo = {
    uuid: getDeviceId(),
    name: Platform.os.family || 'Unknown',
    platform,
    osVersion: Platform.os.version || 'Unknown',
    screen: 'web',
  };

  const fsToken = localStorage.getItem('fireMessagingToken');
  if (fsToken) {
    deviceInfo.firebaseToken = fsToken;
  } else {
    localStorage.setItem('isFcmTokenSent', 'false');
  }

  return deviceInfo;
};

export const generateDetailUrl = (data) => {
  let type;

  switch (data.type) {
    case 'season':
    case 'featured':
    case 'editorial':
      type = 'playlists';
      break;
    case 'webview':
      type = 'live';
      break;
    case 'stream':
      if (data.interactive) {
        type = 'stream';
      } else {
        type = 'live';
      }
      break;

    default:
      type = data.type;
  }

  return `/${type}/${data.id}`;
};

export const generatePlaylistUrl = (id) => {
  if (id === 'clips') return '/clips';
  if (id === 'live-tv') return '/live-tv';
  return `/playlists/${id}`;
};

export const generateGenres = (tags) => {
  const genres = tags && tags.genres;

  return genres && genres.length && genres.join('/');
};

export const generateCasts = (tags) => {
  const casts = tags && tags.casts;

  return casts && casts.length && casts.join(', ');
};

export const formatDuration = (num) => {
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return rhours + 'h' + rminutes + 'm';
};

export const formatSecsDuration = (
  duration,
  { format = 'hh mm ss', delimiter = ':' } = {}
) => {
  const myDate = new Date();
  const tzo = (myDate.getTimezoneOffset() / 60) * -1; // get local timezone in hours
  const date = new Date(duration * 1000);
  date.setHours(date.getHours() + tzo);
  const converDuration = date.toISOString().substr(11, 8).split(':');
  let durations = [];
  let formatedDuration;
  let formatError;

  format.split(' ').map((durationFormat) => {
    switch (durationFormat) {
      case 'hh':
        return durations.push(converDuration[0]);
      case 'mm':
        return durations.push(converDuration[1]);
      case 'ss':
        return durations.push(converDuration[2]);
      default:
        formatError = true;
    }

    return durationFormat;
  });

  if (delimiter) formatedDuration = durations.join(delimiter);
  else formatedDuration = durations.join('');

  return !formatError ? formatedDuration : 'invalid duration format';
};

export const getThumbnail = (item, type) => {
  if (type === CAROUSEL_ITEM_THUMBNAIL) {
    if (window.innerWidth <= 500) {
      return (
        item.attachments &&
        item.attachments.banner_portrait &&
        item.attachments.banner_portrait.fileUrl
      );
    }
  }

  if (item.type === 'campaign') {
    return item?.props?.heroImageWeb;
  }

  return (
    item.attachments && item.attachments[type] && item.attachments[type].fileUrl
  );
};

export const getDetailPoster = (item) => {
  if (item.type === 'episode' || item.type === 'clips') {
    return (
      item.attachments &&
      item.attachments.thumbnail_landscape &&
      item.attachments.thumbnail_landscape.fileUrl
    );
  }

  if (item.type === 'campaign') {
    return item?.props?.heroImageWeb;
  }

  return (
    item.attachments &&
    item.attachments.poster_landscape &&
    item.attachments.poster_landscape.fileUrl
  );
};

export const mergeArrayObjects = (firstArray, secondArray) => {
  return firstArray.map((first) => {
    const selected = secondArray.find((second) => second.id === first.id);
    if (selected) {
      return {
        ...first,
        ...selected,
      };
    }
    return first;
  });
};

export const detectAgent = (type) => {
  if (window.navigator) {
    const isSuitableAgent = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    );
    const deviceWidth = window.innerWidth;
    if (type === 'mobile') return isSuitableAgent && deviceWidth <= 500;
    if (type === 'tablet') return isSuitableAgent && deviceWidth >= 768;
  }
  return false;
};

export const detectOS = () => {
  return Platform.os && Platform.os.family && Platform.os.family.toLowerCase();
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const secondsToTime = (length) => {
  let hours = Math.floor(length / 3600);
  let minutes = Math.floor((length - hours * 3600) / 60);
  let seconds = Math.floor(length - hours * 3600 - minutes * 60);
  let time = '';

  if (hours !== 0) {
    time = hours + ':';
  }
  if (minutes !== 0 || time !== '') {
    minutes = minutes < 10 && time !== '' ? '0' + minutes : String(minutes);
    time += minutes + ':';
  }
  if (time === '') {
    time = seconds + 's';
  } else {
    time += seconds < 10 ? '0' + seconds : String(seconds);
  }
  return time;
};

export const generateTransID = () => {
  const timestamp = new Date().getUTCMilliseconds();
  const prefix = Math.random().toString(36).substring(7);
  return prefix + timestamp;
};

export const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = `${cname}=${cvalue}; ${expires}; domain=${window.location.hostname}; path=/`;
};

export const getCookie = (cname) => {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const checkCookie = (cname) => {
  var exist = getCookie(cname);
  return exist !== '';
};

export const deleteCookie = (cname) => {
  var d = new Date();
  d.setTime(d.getTime() + -1 * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = `${cname}= ; ${expires}; domain=${window.location.hostname}; path=/`;
};

export const currencyFormatter = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  minimumIntegerDigits: 1,
  maximumFractionDigits: 0,
});

export const numberFormat = new Intl.NumberFormat('id-ID', {
  // style: 'currency',
  // currency: 'IDR',
  minimumIntegerDigits: 1,
  maximumFractionDigits: 0,
});

export const isFirebaseMessagingSupported = () => {
  const isMobile = detectAgent('mobile');

  return (
    window.location.protocol === 'https:' &&
    !isMobile &&
    firebase.messaging.isSupported()
  );
};

export const getInitial = (name) => {
  return name
    .split(' ')
    .slice(0, 2)
    .map((n) => n.charAt(0).toUpperCase())
    .reduce((n, space) => n + space);
};

export const formatDate = (date) => {
  const dateNow = new Date().getTime();
  const seconds = Math.floor((dateNow - date) / 1000); // in seconds

  let interval;

  interval = Math.floor(seconds / 2592000); //get months
  //format date for more than 1 year : "YYYY MM DD"
  if (interval >= 13) {
    const dateString = new Date(date);
    const year = dateString.getFullYear();
    const month = dateString.toLocaleString('default', { month: '2-digit' });
    const day = dateString.toLocaleString('default', { day: '2-digit' });

    return `${year}/${month}/${day}`;
  }
  //format date for more than 2 month and less than 1 year : "MM DD"
  if (interval >= 2) {
    const dateString = new Date(date);
    const month = dateString.toLocaleString('default', { month: 'short' });
    const day = dateString.toLocaleString('default', { day: '2-digit' });

    return `${month} ${day}`;
  }
  if (interval >= 1) return `${interval} month ago`;

  interval = Math.floor(seconds / 86400); //get days
  if (interval >= 1 && interval < 30) {
    const week = Math.floor(interval / 7);

    if (week) return `${week} week${week > 1 ? 's' : ''} ago`;
    else return `${interval} day${interval > 1 ? 's' : ''} ago`;
  }

  interval = Math.floor(seconds / 3600); //get hours
  if (interval >= 1 && interval < 24)
    return `${interval} hour${interval > 1 ? 's' : ''} ago`;

  interval = Math.floor(seconds / 60); //get minutes
  if (interval >= 1 && interval < 60)
    return `${interval} min${interval > 1 ? 's' : ''} ago`;

  return `${seconds <= 0 ? 0 : seconds} secs ago`;
};

export const formatDateV2 = (date, format = 'DD dd mmm yyyy') => {
  const dateNow = new Date();
  const tomorrow = new Date(dateNow);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const currentYear = dateNow.getFullYear();
  const currentMonth = dateNow.toLocaleString('default', { month: 'long' });
  const currrentday = dateNow.toLocaleString('default', { day: '2-digit' });
  const tomorrowDay = tomorrow.toLocaleString('default', { day: '2-digit' });

  const dateString = new Date(date);
  const year = dateString.getFullYear();
  const month = dateString.toLocaleString('default', { month: 'long' });
  const day = dateString.toLocaleString('default', { day: '2-digit' });
  let weekday = dateString.toLocaleString('default', { weekday: 'long' });
  const hourMinutes = dateString.toLocaleString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (currentYear === year && currentMonth === month && currrentday === day) {
    weekday = 'Today';
  }

  if (currentYear === year && currentMonth === month && tomorrowDay === day) {
    weekday = 'Tomorrow';
  }

  const generateDate = () => {
    let formattedDate = '';
    if (format.includes('DD')) {
      formattedDate += ` ${weekday}`;
    }
    if (format.includes('dd')) {
      formattedDate += ` ${day}`;
    }
    if (format.includes('mmm')) {
      formattedDate += ` ${month}`;
    }
    if (format.includes('yyyy')) {
      formattedDate += ` ${year}`;
    }
    if (format.includes(',')) {
      formattedDate += `,`;
    }
    if (format.includes('hh:mm')) {
      formattedDate += ` ${hourMinutes}`;
    }

    return formattedDate;
  };

  return generateDate();
};

export const generatedRandomColor = (identifier) => {
  const listColor = [
    'FF7EAC',
    'FF6262',
    'FF7046',
    'FE7D87',
    'F4AFCA',
    'FF855C',
    'DDA27A',
    'FFA41D',
    'FFCA24',
    '97A935',
    'AFF218',
    '45D3CB',
    '3BE8B0',
    '68AEFF',
    'B0A6E5',
    '2C81FB',
    '9661F6',
    '00CE37',
  ];

  const index = identifier.toUpperCase().charCodeAt(0) % 18;
  return `#${listColor[index]}`;
};

export const limitTextMaxCharater100 = (text) => {
  const lengthChart = text.split('').length;
  return text.slice(0, 50) + (lengthChart >= 100 ? '...' : '');
};

export const limitTextMaxCharater120 = (text) => {
  const lengthChart = text.split('').length;
  return text.slice(0, 120) + (lengthChart >= 120 ? '...' : '');
};

export const limitTextMaxCharater = (text, charCount) => {
  const lengthChart = text.split('').length;
  return text.slice(0, 50) + (lengthChart >= charCount ? '...' : '');
};

export const generateErrorDetail = (error) => {
  if (error?.response?.data?.error) {
    const errorDetail = error?.response?.data?.error;

    return {
      code: errorDetail?.code || null,
      message: errorDetail?.message || null,
      details: errorDetail?.details || ['An error occured. Please try again.'],
    };
  }

  return {
    code: null,
    message: 'Network Error',
    details: ['Please check your internet connection and try again'],
  };
};

export const generateSelectChannelURL = (item, { additionalFrontURL } = {}) => {
  // const additionalFrontURL = additionalFrontURL;
  let channelURL;
  if (item.interactive) {
    channelURL = `/stream/${item.id}`;
  } else if (item.interactive === false) {
    channelURL = `/live-tv/${item.id}`;
  } else if (!item.interactive) {
    channelURL = `/${item.type}/${item.id}`;
  }

  if (additionalFrontURL) {
    return `${additionalFrontURL}${channelURL}`;
  }

  return channelURL;
};

export const replacePhoneCountryCode = (phone) => {
  if (phone?.startsWith('8')) return phone;
  if (phone?.startsWith('0')) return phone?.replace(/^0/g, '');

  const findCode = phoneCodes.find(({ code }) => {
    const codeReplaced = code.replace(/\+|-/g, '');
    return phone?.startsWith(codeReplaced) || phone?.startsWith(code);
  });

  if (findCode?.code) {
    const removedCode = phone
      ?.replace(
        new RegExp(`\\${findCode.code}|${findCode.code.replace(/\+/g, '')}`),
        ''
      )
      .replace(/^0/g, '');
    return removedCode;
  }

  return phone;
};

export const convertToSnakeCase = (word) => {
  return word
    .replace(/\.?([A-Z]+)/g, (x, y) => {
      return '_' + y.toLowerCase();
    })
    .replace(/^_/, '');
};

export const formatObject = (object, { customKeyName, excludeKeys } = {}) => {
  const newData = {};

  for (const key in object) {
    if (object[key] && !excludeKeys?.find((item) => item === key)) {
      const newKeyName = customKeyName
        ? `${customKeyName}_${convertToSnakeCase(key)}`
        : convertToSnakeCase(key);

      if (object[key] instanceof Array || object[key] instanceof Object) {
        newData[newKeyName] = JSON.stringify(object[key]);
      } else {
        newData[newKeyName] = object[key];
      }
    }
  }

  return newData;
};

export const generateUserData = (
  user,
  { separateSensitiveData = false } = {}
) => {
  const { account, profile, telco } = user || {};
  const deviceInfo = generateDeviceInfo();

  const formatDeviceInfo = formatObject(deviceInfo, {
    customKeyName: 'device',
  });
  const formatTelcoData =
    telco &&
    formatObject(
      {
        telcoOperator: telco.msisdn,
        telcoMsisdn: telco.operator,
      },
      {
        customKeyName: 'account',
      }
    );
  const formatUserAccount =
    account &&
    formatObject(account, {
      customKeyName: 'account',
    });
  const formatUserProfile =
    profile &&
    formatObject(profile, {
      customKeyName: 'profile',
      excludeKeys: ['topicArn'],
    });

  const userData = {
    ...formatDeviceInfo,
    ...formatTelcoData,
    ...formatUserAccount,
    ...formatUserProfile,
  };

  if (separateSensitiveData) {
    const sensitiveDataKeys = [
      'account_email',
      'account_id',
      'account_name',
      'account_user_id',
      'device_uuid',
      'profile_account_id',
      'profile_id',
      'profile_name',
      'user_id',
    ];
    const sensitiveData = {};
    const regularData = {};

    for (let key in userData) {
      if (sensitiveDataKeys?.includes(key)) sensitiveData[key] = userData[key];
      else regularData[key] = userData[key];
    }

    return {
      sensitiveData,
      regularData,
    };
  }

  return userData;
};
